export interface ITwilioPortability {
  phoneNumber: string
  accountSid: string | null
  portable: boolean
  pinAndAccountNumberRequired: boolean
  notPortableReason: string
  notPortableReasonCode: number | null
  numberType: string
  country: string
  url: string
}

export enum PortRequestStatus {
  'In Progress' = 'In Progress',
  Completed = 'Completed',
  Failed = 'Failed',
  Cancelled = 'Cancelled',
  Declined = 'Declined',
  Approved = 'Approved',
}

export enum PortRequestChannel {
  phone = 'phone',
  fax = 'fax',
}

export enum PortRequestProvider {
  twilio = 'twilio',
  sinch = 'sinch',
}

export enum PortRequestSourceModule {
  phone_management = 'phone_management',
  fax_settings = 'fax_settings',
}

export enum PortRequestReviewStatus {
  requested = 'requested',
  approved = 'approved',
  declined = 'declined',
}

export interface IPortRequestReviewHistory {
  event: string
  actor?: string | null
  timestamp: string
  reason?: string | null
  note?: string | null
  changed_fields?: string[]
}
